import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import useViewport from "../../hooks/useViewport";
import GlobalContext from "../../contexts/store";
import { Get } from "../../api/server";
import TicketSwiper from "../../components/TicketSwiper";
import Ticket from "../../components/Ticket";

export default function ConfirmationPos() {
  const { company } = useContext(GlobalContext);
  const { transaction, event } = useParams();
  const { width } = useViewport();
  const isMobile = width <= 768;
  const [ticketData, setTicketData] = useState([]);

  useEffect(() => {
    async function getCompanyData() {
      const response = await Get(
        `/tickets/pos/getUserTickets/${company?._id}/${transaction}/${event}`
      );
      if (response.length > 0) {
        setTicketData(response);
      }
    }

    company?._id && getCompanyData();
  }, [company?._id, event, transaction]);

  return (
    <>
      <Row className="pt-6 pb-4 md:pt-8 md:pb-6 px-2">
        <Col className="ml-auto mr-auto text-center">
          <h1
            style={{ fontFamily: "goldbold", marginTop: 65, marginBottom: 8 }}
            className="title text-black text-4xl md:text-5xl"
          >
            Purchased Tickets
          </h1>
        </Col>
      </Row>

      <Container className="pb-4 pt-0">
        <Row className="g-3">
          {isMobile ? (
            <>
              {ticketData.length > 0 ? (
                <TicketSwiper events={ticketData} company={company} />
              ) : null}
            </>
          ) : (
            <>
              {ticketData.length > 0
                ? ticketData.map((ticket, index) => (
                    <Col key={index} md={4}>
                      <Ticket
                        ticket={ticket}
                        company={company}
                        bgColor={
                          index % 2 === 0 ? "#1f2251" : "#1f2252"
                        }
                      />
                    </Col>
                  ))
                : null}
            </>
          )}
        </Row>
      </Container>

      <div className="h-6 md:h-8" aria-hidden />
    </>
  );
}